export default Object.freeze({
  TITLE: '적립금 설정',
  BASIC_PAGE_TITLE: '적립금 기본 설정',
  DISCLAIMER: '필수입력',
  MALL: '쇼핑몰',
  RATE: '기본적립률',
  RATE_DESCRIPTION: '상품별 적립금을 설정하지 않은 경우 기본 적립률이 적용됩니다.',
  ACCUMULATION_NAME: '적립금 명칭',
  ACCUMULATION_NAME_DESCRIPTION: '운영 몰에 맞는 명칭을 설정하여 노출할 수 있습니다.',
  DISPLAY_FORMAT_TYPE: '적립금 노출 설정',
  ACCUMULATION_UNIT: '적립금 표시 방식',
  RESEVER_TIME: '적립금 지급 시점',
  PERIOD: '적립금 유효기간 설정',
  EXPIRED_NOTIFICATION_TIME: '적립금 만료일 알림 시점',
  DISPLAY_FORMAT_TYPE_DESCRIPTION: '적립금이 표시되는 영역에 설정한 포맷 형식으로 노출할 수 있습니다.',
  ACCUMULATION_UNIT_DESCRIPTION: 'ex) 점, 원, point, 코인',
  ACCUMULATION_UNIT_ALERT: '입력형식이 잘못되었습니다.',
  CONFIRM_BUY_TITLE: '구매확정 후',
  ACCUMULATION_PAY_DESCRIPTION_1: '운영 중 지급시점을 변경하는 경우 변경 이후 주문 건 부터 적용됩니다.',
  ACCUMULATION_PAY_DESCRIPTION_2: '지급 시점을 단기로 할 경우 주문취소/반품에 대한 처리에 문제가 발생될 수 있습니다. 설정 시 유의하시기 바랍니다.',
  BASE_ON_PAY_TIME: '적립금 지급일 기준',
  PERIOD_DESCRIPTION: '개별 유효기간을 설정한 적립금을 제외한 적립금 유효기간에 적용됩니다.',
  MONTH_UNIT: '개월',
  NOTIFICATION_Y: '사용함',
  NOTIFICATION_N: '사용 안 함',
  BASE_ON_ACCUMULATION: '적립금 만료일 기준',
  SET_NOTIFICATION_CHANNELS: '적립금 만료 알림 설정 수단',
  NOTIFICATION_ALL: '전체선택',
  NOTIFICATION_KAKAO: '카카오 알림톡',
  NOTIFICATION_SMS: 'SMS',
  NOTIFICATION_EMAIL: '이메일',

  ACCUMULATION_PAY_TITLE: '적립금 지급 설정',
  SET_PRODUCT_NUMS: '상품 금액 적립 설정',
  PRODUCT_NUMS: '상품금액 적립 기준을',
  PRODUCT_NUMS_DESCRIPTION_1: '할인 적용가는 판매가에서 즉시 할인 적용된 금액입니다.',
  PRODUCT_NUMS_DESCRIPTION_2: '프로모션 할인은 상품 추가 할인과 상품 쿠폰 할인 금액입니다.',
  PRODUCT_NUMS_DESCRIPTION_3: '총 결제금액에서 해당 기준을 적용하는 것이 아니라,',
  PRODUCT_NUMS_DESCRIPTION_4: '결제한 상품별로 기준을 적용하여 적립금이 지급',
  PRODUCT_NUMS_DESCRIPTION_5: '되는 점 유의하시기 바랍니다.',

  NUM_TYPE_ERR_1: '입력형식이 잘못되었습니다.',
  NUM_MAX_LIMIT_ERR: '999,999,999 이하로 입력해주세요.',
  USE_TRUE: '사용함',
  USE_FALSE: '사용 안 함',
  BTN_SAVE: '적립금 설정 저장',
  BTN_CANCEL: '취소',
  BTN_TEMPORARY: '임시저장',

  SIGN_UP_TITLE: '회원가입적립금',
  SIGN_UP_DESCRIPTION_1: '회원가입 시 최초 1회 지급되는 적립금입니다.',
  SIGN_UP_DESCRIPTION_2: '회원가입완료 시 즉시 지급됩니다.',
  SIGN_UP_DESCRIPTION_3: '적립금은 10원 단위로 입력 가능합니다.',

  REVIEWS_TITLE: '상품평 적립금',
  PRODUCT_REVIEW: '상품평 적립금',
  PHOTO_REVIEW: '포토 상품평 적립금',
  REVIEW_DESCRIPTION_1: '상품평 작성 시 지급되는 적립금을 설정할 수 있습니다.',
  REVIEW_DESCRIPTION_2: '상품평 작성 시 즉시 제공됩니다.',
  REVIEW_DESCRIPTION_3: '적립금은 10원 단위로 입력 가능합니다.',
  REVIEW_DESCRIPTION_4: '상품평 적립금과 포토 상품평 적립금은 중복으로 지급되지 않습니다. (포토 상품평 적립금이 우선순위로 지급됨)',
  REVIEW_MORE: '자 이상',
  REVIEW_SAVING: '적립',

  BIRTHDAY_TITLE: '생일자 회원 적립금',
  BIRTHDAY_DESCRIPTION_1: '회원가입 이후 생일 날짜 기준 일년 1회 지급되는 적립금 입니다.',
  BIRTHDAY_DESCRIPTION_2: '년내 지정된 날짜기준 회원 아이디 1개당 1회 발송됩니다.',
  BIRTHDAY_DESCRIPTION_3: '적립금은 10원 단위로 입력 가능합니다.',
  BIRTHDAY_DESCRIPTION_4: '해당일 기준 대상 회원에게 순차 발송됩니다. 참고해주시기 바랍니다.',
  BIRTHDAY_DESCRIPTION_5: '운영 중 변경된 경우 변경 이후 생일 날짜부터 적용됩니다.',

  APP_INSTALL_TITLE: '앱설치 적립금',
  APP_INSTALL_DESCRIPTION_1: '모바일앱 설치한 회원에게 지급되는 적립금 입니다.',
  APP_INSTALL_DESCRIPTION_2: '앱 삭제 후 재 설치한 회원인 경우 지급된 내용이 있으면 재 지급되지 않습니다.',
  APP_INSTALL_DESCRIPTION_3: '적립금은 10원 단위로 입력 가능합니다.',
  APP_INSTALL_DESCRIPTION_4: '운영 중 변경된 경우 변경 이후 앱 설치 회원부터 변경된 사항으로 적용됩니다.',

  LIMIT_USE_SET_TITLE: '적립금 사용 / 제한 설정',
  MIN_LIMIT_TITLE: '적립금 사용 최소 결제금액 설정',
  LIMIT_N: '제한없음',
  LIMIT_Y: '제한있음',
  MIN_LIMIT_DESCRIPTION_1: '원 이상 구매시 적립금 사용 가능',
  MIN_LIMIT_DESCRIPTION_2: '상품/쿠폰할인 적용된 최종 결제 금액 기준입니다.',

  MIN_PRICE_LIMIT_TITLE: '적립금 사용 최소 적립금 설정',
  MIN_PRICE_LIMIT_POINT_USE: '부터 적립금 사용 가능',
  MIN_PRICE_DESCRIPTION_1: '최소 누적 적립금을 설정한 경우, 설정된 적립금 이상인 경우 사용 가능합니다.',
  MIN_PRICE_DESCRIPTION_2: '적립금은 10원 단위로 입력 가능합니다.',

  MAX_RATE_TITLE: '적립금 사용 최대 적립금 설정',
  MAX_RATE_BEFORE_TEXT: '결제금액 총합계 기준 최대',
  MAX_RATE_AFTER_TEXT: '사용가능',
  MAX_RATE_DESCRIPTION: '적립금 사용 기준 설정시 1 단위로 입력 가능합니다. 작성범위는 1~100% 까지 입니다.',

  EXCLUDE_TITLE: '적립금 지급 제외',
  EXCLUDE_ACCUMULATION: '일부라도 적립금으로 결제하는상품은 적립금을 지급하지 않습니다.',
  EXCLUDE_COUPON: '일부라도 쿠폰 할인으로 결제하는 상품은 적립금을 지급하지 않습니다.',

  MEMO_TITLE: '운영자 전달 메모',
  MEMO_NOTICE: '운영자 메모',

  FORMATE_TYPE_FIXED_AMT: '정액(KRW) 단일표시 (ex 200원)',
  FORMATE_TYPE_FIXED_RATE: '정률(%) 단일표시 (ex 2%)',
  FORMATE_TYPE_FIRST_FIXED_RATE: '정률(%)정액(KRW) 동시표시 (ex 2%/200원)',
  FORMATE_TYPE_FIRST_FIXED_AMT: '정액(KRW)정률(%) 동시표시 (ex 200원/2%)',

  RESERVE_TIME_IMMEDIATE: '즉시적립',
  RESERVE_TIME_NEXTDAY: '익일',
  RESERVE_TIME_DAY_AFTER_TOMMOROW: '2일',
  RESERVE_TIME_AFTER_A_WEEK: '7일',
  RESERVE_TIME_AFTER_TWO_WEEK: '14일',
  RESERVE_TIME_AFTER_TWENTY_DAYS: '20일',
  RESERVE_TIME_AFTER_THIRTY_DAYS: '30일',
  RESERVE_TIME_NEXT_MONTH: '익월',

  VALID_YEAR_0: '0년',
  VALID_YEAR_1: '1년',
  VALID_YEAR_2: '2년',
  VALID_YEAR_3: '3년',
  VALID_YEAR_4: '4년',
  VALID_YEAR_5: '5년',

  VALID_MONTH_0: '0개월',
  VALID_MONTH_1: '1개월',
  VALID_MONTH_2: '2개월',
  VALID_MONTH_3: '3개월',
  VALID_MONTH_4: '4개월',
  VALID_MONTH_5: '5개월',
  VALID_MONTH_6: '6개월',
  VALID_MONTH_7: '7개월',
  VALID_MONTH_8: '8개월',
  VALID_MONTH_9: '9개월',
  VALID_MONTH_10: '10개월',
  VALID_MONTH_11: '11개월',

  NOTIFICATION_BEFORE_DAY_2: '2일전',
  NOTIFICATION_BEFORE_DAY_7: '7일전',
  NOTIFICATION_BEFORE_DAY_14: '14일전',
  NOTIFICATION_BEFORE_DAY_20: '20일전',
  NOTIFICATION_BEFORE_DAY_30: '30일전',

  BASIS_TYPE_SALE_PRICE: '판매가',
  BASIS_TYPE_SALE_STANDARD_PRICE: '판매가 ± 옵션가',
  BASIS_TYPE_SALE_PROMOTION_PRICE: '판매가 ± 옵션가 - 프로모션할인',
  BASIS_TYPE_DISCOUNTED_PRICE: '할인적용가',
  BASIS_TYPE_DISCOUNTED_STANDARD_PRICE: '할인적용가 ± 옵션가',
  BASIS_TYPE_DISCOUNTED_PROMOTION_PRICE: '할인적용가 ± 옵션가 - 프로모션할인',

  ALERT_1: '기본적립률을 정확하게 입력해주세요.',
  ALERT_2: '기본적립률은 소수점 한자리까지 입력가능합니다.',
  ALERT_3: '기본적립률은 소수점 한자리까지 입력가능합니다.',
  ALERT_4: '적립금 유효기간은 최소 1개월이상 입니다.',
  ALERT_5: '적립금은 10원 단위로 입력 가능합니다.',
  ALERT_6: '적립금 사용한도를 정확하게 입력해주세요.',
  ALERT_7: '적립금 설정 저장이 완료되었습니다.',
  ALERT_8: '임시 저장되었습니다.',
  ALERT_9: '기본적립률을 입력해주세요.',
  ALERT_10: '적립금 명칭을 입력하세요.',
  ALERT_11: '적립금 지급 시점을 선택해주세요.',
  ALERT_12: '적립금 유효기간을 선택해주세요.',
  ALERT_13: '적립금 만료일 알림 시점을 선택해주세요.',
  ALERT_14: '적립금 만료알림 수단을 선택해주세요.',
  ALERT_15: '회원가입 적립금을 입력해주세요.',
  ALERT_16: '생일자 회원 적립금을 입력해주세요.',
  ALERT_17: '앱설치 적립금을 입력해주세요.',
  ALERT_18: '상품평 적립금 기준 글자수를 입력해주세요.',
  ALERT_19: '상품평 적립금을 입력해주세요.',
  ALERT_20: '포토상품평 적립금 기준 글자수를 입력해주세요.',
  ALERT_21: '포토상품평 적립금을 입력해주세요.',
  ALERT_22: '적립금 사용 최소 결제금액을 입력해주세요.',
  ALERT_23: '적립금 사용 최소 적립금을 입력해주세요.',
  ALERT_24: '적립금 사용 최대 적립금을 입력해주세요.',

  CONFIRM_1: '작성한 내용을 취소하시겠습니까?',
  CONFIRM_2: '적립금 설정을 임시저장하시겠습니까?',
  CONFIRM_3: '적립금 설정을 완료하시겠습니까?',

  PLACEHOLDER_ENTER: '적립금 입력',
  PLACEHOLDER_ENTER_NUMBER: '글자수 입력',

})
